export const BADGE_ANIMATION_URL =
  "https://public.qiandaocdn.com/interior/images/17c8941ac7e90b45a803dfb23ba6a8b9.json";

async function loadAsset<T>(
  url: string,
  read: (response: Response) => Promise<T>,
  signal: AbortSignal
): Promise<T> {
  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error("徽章资源加载失败");
      return await read(response);
    } catch (error) {
      if (signal.aborted || attempt === 2) throw error;
    }
  }
  throw new Error("徽章资源加载失败");
}

export async function loadBadgeAssets(
  url: string,
  isModel: boolean,
  signal: AbortSignal,
  onProgress: (progress: number) => void
): Promise<{
  animation: Record<string, unknown> | null;
  media: Blob | ArrayBuffer;
}> {
  let completed = 0;
  const settled = () => {
    completed += 1;
    if (!signal.aborted) onProgress((completed / 2) * 100);
  };

  // 只有资源实际完成（或失败）才推进进度，避免原 useAssets 的 100% → 50% 回退。
  const [animation, media] = await Promise.allSettled([
    loadAsset(BADGE_ANIMATION_URL, (res) => res.json(), signal).finally(
      settled
    ),
    loadAsset<Blob | ArrayBuffer>(
      url,
      (res) => (isModel ? res.arrayBuffer() : res.blob()),
      signal
    ).finally(settled),
  ]);

  if (signal.aborted) throw new DOMException("Aborted", "AbortError");
  if (media.status === "rejected") throw media.reason;
  return {
    animation: animation.status === "fulfilled" ? animation.value : null,
    media: media.value,
  };
}
